































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import ImportUserCsvDetail from "@/components/imports/ImportUserCsvDetail.vue";
import ImportLaborWorkerDetail from "@/components/imports/ImportLaborWorkerDetail.vue";
import ImportCourseV1JsonDetail from "@/components/imports/ImportCourseV1JsonDetail.vue";
import ImportStudentCsvDetail from "@/components/imports/ImportStudentCsvDetail.vue";
import { ImportTypes } from "@/getinfo-api/imports2";
import { Import as IImport } from "@/api-v2/import-export/models/import";
import { WorkerImport as IWorkerImport } from "@/api-v2/labor-protection/models/worker-import";
import { ImportDetailInfo as ImportDetail } from "@/components/imports/import-detail-info";
import ImportContractorCsvDetail from "@/components/imports/ImportContractorCsvDetail.vue";

@Component({
  components: {
    ImportContractorCsvDetail,
    ImportStudentCsvDetail,
    ImportCourseV1JsonDetail,
    ImportLaborWorkerDetail,
    ImportUserCsvDetail,
    CustomButton
  }
})
export default class ImportDetailInfo extends Vue {
  @Prop() type!: ImportTypes;
  @Prop() id!: string;
  @Prop() status!: string;
  isLoading: boolean = false;
  importData?: IImport | IWorkerImport;

  data() {
    return {
      importData: undefined
    };
  }

  async getImportByType() {
    try {
      this.isLoading = true;
      this.importData = await ImportDetail.getDetailImport(this.type, this.id);
    } finally {
      this.isLoading = false;
    }
  }

  @Watch("status")
  checkStatus() {
    this.getImportByType();
  }

  created() {
    this.getImportByType();
  }
}
